import { usePageAction } from '@repo/hooks/usePageAction';
import { useAnalyticsSkuViewedContext } from '@repo/segment/Analytics/AnalyticsSkuViewed';

export const useProductCardEvents = (reviewLink?: string) => {
  const { skuImpressionId } = useAnalyticsSkuViewedContext();

  const fireReadFullReviewClick = usePageAction({
    actionName: 'read_full_review_clicked',
    actionSection: 'product_cards_section',
    actionType: 'select',
    actionDestinationUrl: reviewLink,
  });

  const fireAccordionInteraction = usePageAction({
    actionName: 'product_card_editorial_interacted',
    actionSection: 'nerdwallet_take',
    additionalAttributes: {
      sku_impression_id: skuImpressionId,
    },
  });

  const handleReadFullReviewClick = () => {
    fireReadFullReviewClick();
  };

  const handleAccordionInteraction = (actionInput: 'expand' | 'collapse') => {
    fireAccordionInteraction({ action_input: actionInput });
  };

  return { handleReadFullReviewClick, handleAccordionInteraction };
};
